import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Container } from "react-bootstrap";
import Input from "../../UI/Input";
import Select from "../../UI/Select";
import { useDispatch, useSelector } from "react-redux";
import { getStorage } from "../../../services/localStorageService";
import { ShowNotification } from "../../../services/Notifications";
import CalendarField from "../../UI/CalendarField";
import {
  AssignmentStatus,
  createNewReservation,
  fetchReservations,
  SetActiveDriver,
} from "../../../store/actions/fleetReserve.action";
import moment from "moment";
import TimePicker from "../../UI/TimePicker";
import TaskManagerRequest from "../../../services/TaskManagerRequest";

const EditUserReservationModal = (props) => {
  const dispatch = useDispatch();
  const user = getStorage("__user__", "object");

  const [date1, setDate1] = useState(new Date());

  const statusOptions = [
    { value: "Assigned", label: "Assigned", variant: "success" },
    { value: "Not Assigned", label: "Not Assigned", variant: "secondary" },
  ];
  const [toTime, setToTime] = useState(new Date());
  const [fromTime, setFromTime] = useState(new Date());
  const vehicle = useSelector((state) => state.settingReducer.vehicles);
  const taskDrivers = useSelector((state) => state.taskReducer.taskDrivers);
  const activeDriver = useSelector(
    (state) => state.fleetReserveReducer.activeDriver,
  );
  const [task, setTask] = useState(false);

  const assignmentStatus = useSelector(
    (state) => state.fleetReserveReducer.assignmentStatus,
  );
  const [jobDescription, setJobDesctiption] = useState("");
  const selectedDrivers = useSelector(
    (state) => state.taskReducer.selectedDrivers,
  );
  const time = useSelector((state) => state.fleetReserveReducer.time);

  const [selectedDriver, setSelectedDriver] = useState(false);
  const selectedGroups = useSelector(
    (state) => state.taskReducer.selectedGroups,
  );
  const [isLoading, setLoading] = useState(false);
  const activeDriverVehicle = taskDrivers.find((v) => v._id === activeDriver);
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  console.log("task.status", task.status);
  console.log(task);
  const [reservationId, setReservationId] = useState("");
  console.log("selectedStatus", selectedStatus);
const fleetReservation = getStorage("__fleetReservation__", "object");
  useEffect(() => {
    if (props.show === true && props.task) {
      console.log("props.task", props.task);
      console.log("dates in props",props.startDate, props.endDate);
      
      setTask(props.task);
      setReservationId(props.task._id);
      setSelectedStatus(props.task.status || "Not Assigned");
      setJobDesctiption(props.task.description || "");
      setName(props.task.name || "");
      setRole(props.task.createdByRole || "Admin")
     if (props.task.driver != null) {
        setSelectedDriver(props.task.driver._id || "");
      }
      // Parse date safely
      const taskDate = props.task.date ? new Date(props.task.date) : new Date();
      setDate1(taskDate);

      // Parse time strings into Date objects using taskDate as base
      const parseTime = (timeStr) => {
        if (!timeStr) return new Date();
        const [hours, minutes] = timeStr.split(":").map(Number);
        const result = new Date(taskDate);
        result.setHours(hours, minutes, 0, 0);
        return result;
      };

      setFromTime(parseTime(props.task.fromTime));
      setToTime(parseTime(props.task.toTime));
    }
  }, [props.show]);

  // console.log(activeDriverVehicle);
  // console.log("group id =",activeDriverVehicle.group._id,"group Name=",activeDriverVehicle.group.name);

  // const activeDriverName = activeDriverVehicle ? activeDriverVehicle.name : "Unknown Driver";
  // console.log(activeDriverName);
  const handleCloseModal = () => {
    props.toggleModal();
  };
  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    setSelectedStatus(newStatus);
    if (newStatus === "Not Assigned") {
      setSelectedDriver("");
    }
  };

  const tomorrow = new Date(new Date());
  tomorrow.setDate(tomorrow.getDate() + 1);

  const onSelectDriver = (event) => {
    const driverId = event.target.value;

    if (driverId === "") {
      setSelectedDriver(null);
      setSelectedStatus("Not Assigned");
      return;
    }

    const index = taskDrivers.findIndex((c) => c._id === driverId);
    if (index !== -1) {
      setSelectedDriver(driverId); // store only the ID
      setSelectedStatus("Assigned");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!date1) {
      ShowNotification("error", "Date is required");
      return;
    }
    if (selectedStatus === "Not Assigned" && selectedDriver) {
      setSelectedDriver(null);
      ShowNotification(
        "warning",
        "Status is Not Assigned, removing driver selection",
      );
      return;
    }

    const formData = new FormData(event.target);
    const data = Object.fromEntries(formData.entries());
    if (selectedStatus === "Assigned" && !selectedDriver) {
      ShowNotification(
        "error",
        "You selected status as Assigned but no driver is selected",
      );
      return;
    }

    // Format the date from state to 'YYYY-MM-DD'
    const formattedDate = moment(date1).format("YYYY-MM-DD");

    let duration = "";
 let driverId = data.driver;
    if (driverId === "") driverId = null;
    data[`fromTime`] = moment(fromTime).format("HH:mm");
    data[`toTime`] = moment(toTime).format("HH:mm");
    if (fromTime && toTime) {
      const startHours = fromTime.getHours();
      const startMinutes = fromTime.getMinutes();
      const endHours = toTime.getHours();
      const endMinutes = toTime.getMinutes();

      const diff =
        endHours * 60 + endMinutes - (startHours * 60 + startMinutes);
      duration = `${Math.floor(diff / 60)}h ${diff % 60}m`;
    }

    const payload = {
      ...data,
      date: formattedDate,
      duration,
      driver: driverId,
      status: selectedStatus,
      createdByRole: role,
      group:
        selectedStatus != "Not Assigned"
          ? activeDriverVehicle?.group?._id
          : null,
    };
console.log("payload", payload);
 const formattedStartDate = moment(props.startDate).format("YYYY-MM-DD 00:00:00");
    const formattedEndDate = moment(props.endDate).format("YYYY-MM-DD 23:59:59");
    
    const _d = {
      startDate: formattedStartDate,
      endDate:formattedEndDate,
      createdByRole: fleetReservation.username,
    };

    payload["_id"] = reservationId;
    console.log("The current Payload data", payload);

    if (selectedStatus === "Assigned") {
      await dispatch(SetActiveDriver(payload.driver));
    }
    try {
      setLoading(true);
      const response = await TaskManagerRequest(
        "/fleet/update/driver/reservation",
        payload,
      );

      ShowNotification("success", "Reservation Edited successfully");
      props.toggleModal();
      await dispatch(AssignmentStatus(true))
      await dispatch(fetchReservations(_d)); // Refetch rides to update the list

      setSelectedDriver("");
    } catch (error) {
      ShowNotification("error", "Failed to Edit Reservation");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setSelectedDriver(activeDriver);
  }, [activeDriver]);

  return (
    <Modal
      show={props.show}
      dialogClassName="modal-60w"
      onHide={props.toggleModal}
    >
      <Modal.Header closeButton>
        Edit Reservation
        {/* Status Selector - Now positioned in the Header */}
      </Modal.Header>

      <form onSubmit={handleSubmit}>
        <Modal.Body className="show-grid">
          <Container>
            {/* Ride Name */}
            <div className="ms-auto d-flex align-items-center">
              <span className="me-2" style={{ fontSize: "14px" }}>
                Assignment Status:
              </span>
              <div className="d-flex align-items-center">
                <div
                  className="me-2"
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor:
                      selectedStatus === "Assigned" ? "#28a745" : "#6c757d",
                  }}
                ></div>
                <select
                  name="status"
                  value={selectedStatus}
                  onChange={handleStatusChange}
                  className="form-select form-select-sm custom-select-no-focus:focus"
                  style={{
                    minWidth: "130px",
                    outline: "none",
                    boxShadow: "none",
                  }}
                >
                  {statusOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-12">
                <Input name="name" label="Name" value={name} required />
              </div>
            </div>

            {/* Date and Vehicle Selection */}
            <div className="row mb-3">
              <div className="col-6">
                <div className="row">
                  <div className="col-md-7">
                    <CalendarField
                      label="Date"
                      selected={date1}
                      onChange={(date) => setDate1(date)}
                    />
                  </div>
                  <div className="col-md-5 d-flex p-1 pt-3 pb-2 float-right">
                    <button
                      type="button"
                      className="btn btn-theme date-button font-10 mb-0 mr-2"
                      onClick={() => setDate1(new Date())}
                    >
                      Today
                    </button>
                    <button
                      type="button"
                      className="btn btn-theme font-10 mb-0"
                      onClick={() => setDate1(tomorrow)}
                    >
                      Tomorrow
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <Select
                  title={`Field Staff`}
                  className="form-select"
                  name="driver"
                  value={selectedDriver}
                  onChange={onSelectDriver}
                >
                  <option value="">Select Field Staff</option>
                  {taskDrivers.map((driver, i) => (
                    <option key={i} value={driver._id}>
                      {driver.name}
                    </option>
                  ))}
                </Select>
              </div>
            </div>

            {/* Time Inputs */}
            <div className="row mb-6">
              <div className="col-md-6 pr-0">
                <TimePicker
                  value={fromTime}
                  label="From Time"
                  onChange={(date) => setFromTime(date)}
                />
              </div>
              <div className="col-md-6">
                <TimePicker
                  value={toTime}
                  label="To Time"
                  onChange={(date) => setToTime(date)}
                />
              </div>
            </div>

            {/* Notes */}
            <div className="row mb-3">
              <div className="col-md-12">
                <textarea
                  name="description"
                  className="form-control"
                  rows={3}
                  value={jobDescription}
                  onChange={(e) => setJobDesctiption(e.target.value)} // <-- this line is important
                  placeholder="Additional notes..."
                  style={styles.textarea}
                ></textarea>
              </div>
            </div>
          </Container>
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            style={{ fontSize: "12px" }}
            className="btn btn-small"
            onClick={handleCloseModal}
          >
            Cancel
          </button>
          <button
            style={{
              fontSize: "12px",
              backgroundColor: "#007bff",
              color: "#ffffff",
            }}
            className="btn btn-small"
            disabled={isLoading}
            id="createTaskButton"
          >
            Edit Reservation
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

// Updated styles
const styles = {
  textarea: {
    fontSize: "14px",
  },
};
<style jsx="true">{`
  .custom-select-no-focus:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: #ced4da !important;
  }

  select:invalid {
    border-color: #ced4da !important;
    box-shadow: none !important;
  }
`}</style>;

export default EditUserReservationModal;
